'use client';

import NextNProgress, { NextNProgressProps } from 'nextjs-progressbar';

const CustomNextProgress = (props: NextNProgressProps) => (
	<NextNProgress
		height={4}
		color="#373593"
		showOnShallow
		options={{
			showSpinner: false,
		}}
		{...props}
	/>
);

export default CustomNextProgress;
